import React from 'react';
import _ from 'lodash'
import { Link } from 'react-router-dom'
import Service from './actions/service'
import MenuBottom from './MenuBttm'
import MenuItem from './MenuItem'

class Component extends React.Component{
  constructor(props) {
    super(props)
    // let selected = false
    let selected = props.mainid ? props.mainid : false
    let st_addit = false
    let st_eddit = false
    let collect_field_value = ""
    this.inputs = []
    this.state = { selected, st_addit, st_eddit, collect_field_value }
  }
  handleChange = (selected) => (event) => {
    this.setState({ collect_field_value: event.target.value })
  }
  handleKeyPress = (event) => {
    const { st_addit, st_eddit } = this.state
    if(event.key === 'Enter'){
      st_addit && this.handleSaveItem()
      st_eddit && this.handleSaveEdit()
    }
  }
  handleNewItem() {
    const { st_addit, selected } = this.state
    this.setState({ 
      collect_field_value: "", 
      st_addit: !st_addit, 
      st_eddit: false
    }, () => {
      this.inputs[selected] && this.inputs[selected].focus()
    })
  }
  handleEditItem() {
    const { st_eddit, selected } = this.state
    const selctd_model = this.returnSelectedModel()
    const parent_model = this.returnSelectedParentModel()
    if(!selctd_model || !parent_model) return false
    this.setState({ 
      collect_field_value: selctd_model.name, 
      st_addit: false, 
      st_eddit: !st_eddit 
    }, () => {
      this.inputs[selected] && this.inputs[selected].focus()
    })
  }
  handleCancelEdit() {
    const { st_addit, st_eddit } = this.state
    this.setState({ 
      collect_field_value: "", 
      st_addit: false, 
      st_eddit: false 
    });
  }
  returnSelectedModel() {
    const { menu } = this.props
    const { selected } = this.state
    const selected_model = _.find(menu, {_id: selected})
    if(!selected_model || selected_model.path === "/") {
      console.log("false")
      return false
    }
    return selected_model
  }
  returnSelectedParentModel() {
    const { menu } = this.props
    const { selected } = this.state
    const selected_model = _.find(menu, {_id: selected})
    if(!selected_model || selected_model.path === "/") {
      console.log("false")
      return false
    }
    const parent_model = _.find(menu, {_id: selected_model.parent})
    return parent_model
  }
  async handleDeleteItem() {
    const { functions } = this.props
    const { selected } = this.state
    const parent_model = this.returnSelectedParentModel()
    if(!parent_model) return false
    await Service.deleteCollection(selected)
    this.setState({ selected: parent_model._id })
    // this.props.reloadMenu()
    functions.handleRoot()
  }
  async handleSaveItem() {
    const { menu, mainid, functions } = this.props
    const { selected, collect_field_value } = this.state
    // if(!selected) return false
    const name = collect_field_value
    const parent = selected ? selected : mainid
    const path = name.replace(/\s/g, '').toLowerCase()
    const parentmodel = _.find(menu, {_id: parent})
    const fullpath = parentmodel && parentmodel.path !== "/" ? `${parentmodel.path}/${path}` : `${path}`
    // console.log(path, fullpath, parentmodel.path)
    const body = { name, parent, path: fullpath }
    const payload = await Service.saveCollection(body)
    const itemid = payload._doc._id
    functions.handleRoot()
    this.handleSelected(itemid)
  }
  async handleSaveEdit() {
    const { functions } = this.props
    const { selected, collect_field_value } = this.state
    if(!selected || collect_field_value.length === "0") return false
    const body = { name: collect_field_value }
    const payload = await Service.updateCollection(selected, body)
    functions.handleRoot()
    this.setState({ 
      st_addit: false, 
      st_eddit: false
    })
  }
  handleSelectItem() {
    const { selected, st_addit, st_eddit, collect_field_value } = this.state

    if((st_addit && collect_field_value.length === 0) || 
      (!st_addit && !selected)) 
      return false

    if(st_eddit && collect_field_value.length === 0) 
      return false

    if(st_addit) this.handleSaveItem() 

    if(st_eddit) this.handleSaveEdit() 
  }
  handleSelected(itemid) {
    const { menu } = this.props
    let { selected } = this.state
    if(itemid === selected) {
      const s_parent = _.find(menu, {_id: itemid})
      selected = s_parent ? s_parent.parent : ""
    } else {
      selected = itemid
    }
    this.setState({ 
      st_addit: false, 
      st_eddit: false,
      selected 
    })
  }
  renderField(id) {
    return (
      <div className="dpto-wrap">
        <div className="dpto-wrap-left">
          <p className="dpto-item-icon">/</p>
        </div>
        <div className="dpto-wrap-center">
          <input 
            type="text" 
            defaultValue={this.state.collect_field_value}
            onKeyPress={this.handleKeyPress}
            onChange={this.handleChange("collect_field_value")} 
            ref={(input) => { this.inputs[id] = input }} 
          />
        </div>
        <div className="dpto-wrap-right">
        </div>
      </div>
    )
  }
  renderItem(item, k) {
    const { functions, mainid, menu } = this.props
    const { selected, st_addit, st_eddit } = this.state
    const _functions = { 
      ...functions, 
      renderSubs: this.renderSubs.bind(this),
      renderField: this.renderField.bind(this),
      handleSelected: this.handleSelected.bind(this)
    }
    const props = {
      item, 
      functions: _functions, 
      mainid, 
      menu, 
      selected, 
      st_addit, 
      st_eddit
    }
    return (
      <MenuItem {...props} key={k} />
    )
  }
  renderSubs(parent) {
    const { menu } = this.props
    const root_sb = _.filter(menu, {parent: parent})
    const ordered = root_sb.sort((a, b) => a.name.localeCompare(b.name))
    return (
      <React.Fragment>{
        _.map(ordered, (item, k) => {
          return this.renderItem(item, k)
        })
      }</React.Fragment>
    )
  }
  renderModal() {
    const { mainid, menu, functions, logged } = this.props
    const { selected, st_addit, st_eddit, collect_field_value } = this.state
    const root_md = _.find(menu, {path: "/"})
    const root_id = root_md ? root_md._id.toString() : "0"
    const root_sb = _.filter(menu, {parent: root_id})
    const ordered = root_sb.sort((a, b) => a.name.localeCompare(b.name))
    const bttn_sv = st_addit && (collect_field_value.length > 0) ? " pri" : !st_addit && selected && root_id !== selected ? " pri" : " thi"
    return (
      <div className="menu-body">
        <div className="parent-body-contnt">
          { 
            _.map(ordered, (item, k) => {
              return this.renderItem(item, k)
            })
          }
          <div className="dpto-newf">
            {
              (!selected || root_id === selected) && 
                st_addit && this.renderField(root_id)
            }
          </div>
        </div>
        <MenuBottom 
          bttn_sv={bttn_sv}
          logged={logged}
          st_addit={st_addit}
          st_eddit={st_eddit}
          functions={functions}
          handleNewItem={this.handleNewItem.bind(this)}
          handleEditItem={this.handleEditItem.bind(this)}
          handleCancelEdit={this.handleCancelEdit.bind(this)}
          handleSelectItem={this.handleSelectItem.bind(this)}
          handleDeleteItem={this.handleDeleteItem.bind(this)}
        />
      </div>
    )
  }
  render() {
    const { menu, functions } = this.props
    if(!menu) return false
    return (
      <div className="main-menu-wrap">
        <button onClick={() => functions.handleMenu()}>
          <div className="main-menu-opac"></div>
        </button>
        <div className="main-menu">
          <div className="main-menu-top">
            <button onClick={() => functions.handleMenu()}>
              <i className="material-icons">close</i>
            </button>
          </div>
          <div className="main-menu-title">
            <Link to={`/`} onClick={() => functions.handleClea()}>PAREDES DO PORTO</Link>
          </div>
          { this.renderModal() }
        </div>
      </div>
    )
  }
}
export default Component;